// extracted by mini-css-extract-plugin
module.exports = {"highlightOptions":"style__highlightOptions__fP4ys"};